exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bg-altaTable{background-color:#f4cdcd;border:1px solid #f6adad}.bg-mediaTable{background-color:#fff2cc;border:1px solid #f6db8a}.bg-destacadoTable{background-color:#d9ead3;border:1px solid #c3eab5}.bg-sinrangoTable{background-color:#eceeec;border:1px solid #d4d5d3}.custom-tooltip-apexchart{position:absolute;background-color:#fff;color:#333;border:1px solid #ccc;padding:10px;border-radius:4px;box-shadow:0 2px 4px rgba(0,0,0,.2);z-index:9999;font-family:Arial,sans-serif;display:none;opacity:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-22b29fd9","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/cultura/tableGroupsResult.vue
// module id = 1096
// module chunks = 2